import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

const PublicLayout = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className='flex min-h-screen flex-col'>
      <main className='flex flex-1 items-center justify-center bg-background'>
        <Outlet />
      </main>
    </div>
  );
};

export default PublicLayout;
